import type { FC } from 'react'

export const PpgOnlyYidDeletionNote: FC =
  import.meta.env.VITE_MODE === 'ppg' ? YidDeletionNote : EmptyNote

function YidDeletionNote() {
  return (
    <p>※Yahoo! JAPAN IDを削除しても、ID削除前の予約はキャンセルされませんのでご注意ください。</p>
  )
}

function EmptyNote() {
  return null
}
